import { Field } from "lib/headlessui/components/field/field";
import { Label } from "lib/headlessui/components/label/label";
import { Switch } from "lib/headlessui/components/switch/switch";
import React from "react";

interface ToggleProps {
    label: React.ReactNode;
    onChange: (isChecked: boolean) => void;
    checked: boolean;
    disabled?: boolean;
}

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
}

export const Toggle: React.FC<ToggleProps> = props => {
    const { label, onChange, checked, disabled } = props;

    const labelClassName =
        typeof label === "string" ? "text-sm font-medium text-gray-900" : "";

    return (
        <Field as="div" className="flex items-center">
            <Switch
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                className={classNames(
                    checked ? "bg-brand-600" : "bg-gray-200",
                    disabled && "opacity-70 cursor-not-allowed",
                    "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-brand-300 focus:ring-offset-1",
                )}>
                <span
                    aria-hidden="true"
                    className={classNames(
                        checked ? "translate-x-5" : "translate-x-0",
                        "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
                    )}
                />
            </Switch>
            {label ? <Label className={`ml-3 ${labelClassName}`}>{label}</Label> : null}
        </Field>
    );
};
